import {fullIconPath} from '../../../utils/images'

export const CuiIconNames = {
  control: 'select',
  options: [
    'alert',
    'allDone',
    'appleStore',
    'archive',
    'arrowDown',
    'arrowForward',
    'arrowLeft',
    'bell',
    'calendar',
    'calendarArrowLeft',
    'calendarArrowRight',
    'cart',
    'checkmark',
    'checkmarkCircle',
    'checkmarkCircle2',
    'checkmarkDouble',
    'chevronDown',
    'chevronRight',
    'chevronUp',
    'clock',
    'close',
    'cookingPan',
    'dairyFree',
    'easyAndConvenient',
    'edit',
    'eggsAndDairy',
    'everChangingMenu',
    'diagonalArrowRightUp',
    'facebook',
    'favorite',
    'favorites',
    'featured',
    'filter',
    'fire',
    'flashIcon',
    'flexiblePlans',
    'forbidden',
    'friend',
    'glutenFree',
    'gift',
    'handCrafted',
    'heart',
    'heartFilled',
    'highCalories',
    'highFat',
    'highProtein',
    'history',
    'hundreds',
    'infoEmptyCircled',
    'info',
    'infoIcon',
    'instagram',
    'keto',
    'layers',
    'linkedin',
    'lowCalories',
    'lowCarbs',
    'lowFat',
    'lowSodium',
    'lowSugar',
    'meals',
    'meat',
    'menu',
    'messageCircle',
    'messageSquare',
    'minus',
    'mixMatch',
    'moreCircle',
    'nutFree',
    'nutrition',
    'options',
    'orders1',
    'orders2',
    'orders3',
    'orders4',
    'paleo',
    'percent',
    'person',
    'plantBased',
    'playStore',
    'plus',
    'plusCircle',
    'pork',
    'poultry',
    'poultry2',
    'questionMarkCircle',
    'questionMarkSquare',
    'retweet',
    'reviewStars1',
    'reviewStars2',
    'reviewStars3',
    'seafood',
    'search',
    'shoppingCart',
    'slickNext',
    'slickPrev',
    'small',
    'sorting',
    'soyFree',
    'spicy',
    'spicyIcon',
    'star',
    'superFood1',
    'superFood2',
    'sync',
    'timer',
    'toggleRight',
    'truck',
    'twitter',
    'vegan',
    'vegetarian',
    'vegetarian2',
    'verySpicy',
    'warning',
    'yourTopRated',
    'youVeTried'
  ],
  defaultValue: 'heart'
}

export const icons = {
  alert: fullIconPath('alert-circle.svg'),
  alertTriangle: fullIconPath('alert-triangle.svg'),
  allDone: fullIconPath('all-done.svg'),
  appleStore: fullIconPath('apple-store.svg'),
  archive: fullIconPath('archive.svg'),
  arrowDown: fullIconPath('arrow-down.svg'),
  arrowForward: fullIconPath('arrow-forward.svg'),
  arrowLeft: fullIconPath('arrow-left.svg'),
  bell: fullIconPath('bell.svg'),
  billing: fullIconPath('billing.svg'),
  calendar: fullIconPath('calendar.svg'),
  calendarArrowLeft: fullIconPath('calendar-arrow-left.svg'),
  calendarArrowRight: fullIconPath('calendar-arrow-right.svg'),
  cart: fullIconPath('shopping-cart.svg'),
  checkmark: fullIconPath('checkmark.svg'),
  checkmarkCircle: fullIconPath('checkmark-circle.svg'),
  checkmarkCircle2: fullIconPath('checkmark-circle-2.svg'),
  checkmarkDouble: fullIconPath('checkmark-double.svg'),
  chevronDown: fullIconPath('chevron-down.svg'),
  chevronLeft: fullIconPath('chevron-left.svg'),
  chevronRight: fullIconPath('chevron-right.svg'),
  chevronUp: fullIconPath('chevron-up.svg'),
  clock: fullIconPath('clock.svg'),
  close: fullIconPath('close.svg'),
  cookingPan: fullIconPath('cooking-pan.svg'),
  dairyFree: fullIconPath('dairy-free.svg'),
  crustaceanShellfish: fullIconPath('shellfish.svg'),
  diagonalArrowRightUp: fullIconPath('diagonal-arrow-right-up.svg'),
  easyAndConvenient: fullIconPath('easy-and-convenient.svg'),
  edit: fullIconPath('edit.svg'),
  eggs: fullIconPath('eggs.svg'),
  eggsAndDairy: fullIconPath('eggs-and-dairy.svg'),
  everChangingMenu: fullIconPath('ever-changing-menu.svg'),
  facebook: fullIconPath('facebook.svg'),
  favorite: fullIconPath('favorite-icon.svg'),
  favorites: fullIconPath('favorites.svg'),
  featured: fullIconPath('featured.svg'),
  filter: fullIconPath('filter.svg'),
  fire: fullIconPath('fire.svg'),
  fish: fullIconPath('fish.svg'),
  flashIcon: fullIconPath('flash.svg'),
  flexiblePlans: fullIconPath('flexible-plans.svg'),
  forbidden: fullIconPath('forbidden.svg'),
  friend: fullIconPath('friend.svg'),
  glutenFree: fullIconPath('gluten-free.svg'),
  gift: fullIconPath('gift.svg'),
  handCrafted: fullIconPath('hand-crafted.svg'),
  heart: fullIconPath('heart.svg'),
  heartFilled: fullIconPath('heart-filled.svg'),
  highCalories: fullIconPath('high-calories.svg'),
  highFat: fullIconPath('high-fat.svg'),
  highProtein: fullIconPath('high-protein.svg'),
  history: fullIconPath('history.svg'),
  hundreds: fullIconPath('hundreds.svg'),
  info: fullIconPath('info.svg'),
  infoEmptyCircled: fullIconPath('info-empty-circled.svg'),
  infoIcon: fullIconPath('info-icon.svg'),
  instagram: fullIconPath('instagram.svg'),
  keto: fullIconPath('keto.svg'),
  ketogenic: fullIconPath('keto.svg'),
  layers: fullIconPath('layers.svg'),
  linkedin: fullIconPath('linkedin.svg'),
  lowCalories: fullIconPath('low-calories.svg'),
  lowCarbs: fullIconPath('low-carbs.svg'),
  lowFat: fullIconPath('low-fat.svg'),
  lowSodium: fullIconPath('low-sodium.svg'),
  lowSugar: fullIconPath('low-sugar.svg'),
  meals: fullIconPath('meals.svg'),
  meat: fullIconPath('meat.svg'),
  mediterranean: fullIconPath('mediterraneanDiet.svg'),
  menu: fullIconPath('menu.svg'),
  messageCircle: fullIconPath('message-circle.svg'),
  messageSquare: fullIconPath('message-square.svg'),
  milk: fullIconPath('milk.svg'),
  minus: fullIconPath('minus.svg'),
  mixMatch: fullIconPath('mix-match.svg'),
  moreCircle: fullIconPath('more-circle.svg'),
  nutFree: fullIconPath('nut-free.svg'),
  nutrition: fullIconPath('nutrition.svg'),
  options: fullIconPath('options.svg'),
  orders1: fullIconPath('orders-1.svg'),
  orders2: fullIconPath('orders-2.svg'),
  orders3: fullIconPath('orders-3.svg'),
  orders4: fullIconPath('orders-4.svg'),
  paleo: fullIconPath('paleo.svg'),
  peanuts: fullIconPath('peanuts.svg'),
  percent: fullIconPath('percent.svg'),
  person: fullIconPath('person.svg'),
  pescatarian: fullIconPath('pescatarianDiet.svg'),
  pescatarianDiet: fullIconPath('pescatarianDiet.svg'),
  plantBased: fullIconPath('plant-based.svg'),
  playStore: fullIconPath('google-play.svg'),
  plus: fullIconPath('plus.svg'),
  plusCircle: fullIconPath('plus-circle.svg'),
  pork: fullIconPath('pork.svg'),
  poultry: fullIconPath('poultry.svg'),
  poultry2: fullIconPath('poultry-2.svg'),
  questionMarkCircle: fullIconPath('question-mark-circle.svg'),
  questionMarkSquare: fullIconPath('question-mark-square.svg'),
  retweet: fullIconPath('retweet.svg'),
  reviewStars1: fullIconPath('review-stars-1.svg'),
  reviewStars2: fullIconPath('review-stars-2.svg'),
  reviewStars3: fullIconPath('review-stars-3.svg'),
  seafood: fullIconPath('seafood.svg'),
  search: fullIconPath('search.svg'),
  shoppingCart: fullIconPath('shopping-cart.svg'),
  sesameSeeds: fullIconPath('sesame-seeds.svg'),
  slickNext: fullIconPath('slick-next.svg'),
  slickPrev: fullIconPath('slick-prev.svg'),
  small: fullIconPath('small.svg'),
  sorting: fullIconPath('sorting.svg'),
  soybeans: fullIconPath('soy-free.svg'),
  soyFree: fullIconPath('soy-free.svg'),
  spicy: fullIconPath('spicy.svg'),
  spicyIcon: fullIconPath('spicy-icon.svg'),
  star: fullIconPath('star.svg'),
  starFull: fullIconPath('starfull.svg'),
  superFood1: fullIconPath('super-food-1.svg'),
  superFood2: fullIconPath('super-food-2.svg'),
  sync: fullIconPath('sync.svg'),
  timer: fullIconPath('timer.svg'),
  toggleRight: fullIconPath('toggle-right.svg'),
  trash: fullIconPath('trash.svg'),
  treeNuts: fullIconPath('tree-nuts.svg'),
  truck: fullIconPath('truck.svg'),
  twitter: fullIconPath('twitter.svg'),
  vegan: fullIconPath('vegan.svg'),
  vegetarian: fullIconPath('vegetarian-icon.svg'),
  vegetarian2: fullIconPath('vegetarian-2.svg'),
  verySpicy: fullIconPath('very-spicy.svg'),
  warning: fullIconPath('warning-icon.svg'),
  wheat: fullIconPath('wheat.svg'),
  yourTopRated: fullIconPath('your-top-rated.svg'),
  youVeTried: fullIconPath('you_ve-tried.svg')
}
